import * as tslib_1 from "tslib";
import React from 'react';
import { BiLoggerContextProvider } from '../biLogger';
import { getDeviationResourceType } from '../DeviationViews/_helpers';
import ActionBarContent from './_partials/ActionBarContent/ActionBarContent';
var ActionBar = function (props) {
    return (React.createElement(BiLoggerContextProvider, { value: {
            itemid: props.deviation.deviationId,
            typeid: getDeviationResourceType(props.deviation),
        } },
        React.createElement(ActionBarContent, tslib_1.__assign({}, props))));
};
ActionBar.displayName = 'ActionBar';
export default ActionBar;
//# sourceMappingURL=ActionBar.js.map